<template lang="pug">
  .confirm-container(@touchmove.prevent)
    popup(@close="close('2')")
      .confirm-content
        .close(@click="close('1')")
          img(src="https://m.hellobike.com/resource/AppPlatformH5/common/eYrQxkxleJVQJOsejs16i.png", alt="alt")
        .title 温馨提示
        .description 您正在购买的是哈啰APP专享卡，购买后仅限哈啰APP使用，确认需要购买吗？
        .alert.flex-mid
          .sign.flex-mid
          span 仅限哈啰APP骑行使用
        .footer
          .btn(@click="onLeft") {{leftBtn}}
          .btn.actived(@click="onRight") {{rightBtn}}
</template>

<script>
import popup from './popup';

export default {
  components: {
    popup,
  },
  props: {
    leftBtn: {
      type: String,
      default: '暂不购买',
    },
    rightBtn: {
      type: String,
      default: '继续购买',
    },
    appendToBody: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    if (this.appendToBody) {
      this.$nextTick(() => {
        document.body.appendChild(this.$el);
      });
    }
  },
  methods: {
    close(type = '1') {
      this.$emit('close', type);
    },
    onLeft() {
      this.$emit('onLeft');
    },
    onRight() {
      this.$emit('onRight');
    },
  },
};
</script>

<style lang="less" scoped>

.confirm-container {
  font-size: 16px;

  .confirm-content {
    position: relative;
    padding-top: 0.24rem;
    width: 100vw;
  }

  .close {
    position: absolute;
    top: 0.2rem;
    right: 0.2rem;

    img {
      width: 0.2rem;
      height: 0.2rem;
    }
  }

  .title {
    color: #242729;
    font-size: 0.2rem;
    font-weight: 500;
    padding: 0.02rem 0 0 0;
  }

  .description {
    font-size: 0.14rem;
    color: #5a6066;
    width: 2.88rem;
    margin: 0.12rem auto 0.16rem;
  }

  .alert {
    width: 2.72rem;
    height: 0.48rem;
    background: rgba(254, 244, 231, 0.6);
    border-radius: 0.02rem;
    margin: 0 auto;
    font-size: 0.16rem;
    font-weight: 500;
    color: #ff5526;

    .sign {
      width: 0.16rem;
      height: 0.16rem;
      border: 0.01rem solid #ff5526;
      border-radius: 50%;
      position: relative;
      margin-right: 0.05rem;

      &::after {
        content: '!';
        position: absolute;
        left: 50%;
        top: 50%;
        font-size: 0.1rem;
        color: #ff4426;
        transform: translate(-50%, -50%);
      }
    }
  }

  .footer {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    padding: 0.16rem 0 0 0;

    .btn {
      width: 1.68rem;
      height: 0.48rem;
      line-height: 0.48rem;
      border-radius: 0.08rem;
      border: 1px solid #08f;
      font-size: 0.16rem;
      color: #08f;
      text-align: center;

      &.actived {
        background: #08f;
        color: #fff;
        border-width: 0;
      }
    }
  }
}
</style>
